import { render, staticRenderFns } from "./MMP_DPR_NewVehicle.vue?vue&type=template&id=2822f889&scoped=true&"
import script from "./MMP_DPR_NewVehicle.vue?vue&type=script&lang=js&"
export * from "./MMP_DPR_NewVehicle.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DPR_NewVehicle.vue?vue&type=style&index=0&id=2822f889&prod&scoped=true&lang=css&"
import style1 from "./MMP_DPR_NewVehicle.vue?vue&type=style&index=1&id=2822f889&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822f889",
  null
  
)

export default component.exports